/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';
import {QuestionnaireSettingsModel} from "../../models/questionnaire-settings-model";


export interface QuestionnaireSettingsPutParams {
    questionnaireGuid?: string;
    body: QuestionnaireSettingsModel;
}

export function questionnaireSettingsPut(http: HttpClient, rootUrl: string, params: QuestionnaireSettingsPutParams, headers: HttpHeaders, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(rootUrl, questionnaireSettingsPut.PATH, 'put');

    for (let headerKey of headers.keys()) {
        rb.header(headerKey, headers.get(headerKey));
    }

    rb.body(params.body, 'application/json');

    if (params) {
        rb.path('questionnaireGuid', params.questionnaireGuid, {"style":"simple"});
    }

    return http.request(
        rb.build({ responseType: 'json', accept: '*/*', context })
    ).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<void>;
        })
    );
}

questionnaireSettingsPut.PATH = '/api/v1/questionnaires/{questionnaireGuid}/settings';
